// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { languageMenuStyles } from "@sc/Overrides/Widgets/Common/LanguageMenu";
import Globe from "@sc/XDL/Icons/Globe";
import { color } from "@sc/XDL/Utilities";
import { css } from "styled-components";

languageMenuStyles.languageWrapper = {
    css: css`
        display: flex;
        align-items: center;
    `,
};

languageMenuStyles.languageIcon = {
    size: 14,
    src: Globe,
    color: "common.ui1",
    css: css`
        margin-right: 8px;
        opacity: 0.66;
    `,
};

languageMenuStyles.languageSelect = {
    cssOverrides: {
        formInputWrapper: css`
            width: auto;
        `,
    },
    iconProps: {
        css: css`
            display: none;
        `,
    },
    css: css`
        &&&&& {
            border: none;
            background-color: ${color("common.ui9")};
            text-transform: uppercase;
            padding: 0;
            font-size: 14px;
            line-height: 22px;
            font-weight: bold;
            color: ${color("common.white")};
            height: 22px;
            cursor: pointer;
        }
        &&&&&&:hover {
            border: none;
        }
        &&&&&&:focus {
            padding: 0;
        }
    `,
};
